// extracted by mini-css-extract-plugin
module.exports = {"partner":"_1iK59","name":"sdgCh","description":"_3Zr_0","maskWrapper":"_10dG-","threeDotsButton":"_2NNVf","employeesTable":"_20amP"};